import { isUndefined, omitBy } from 'lodash';

export function buildPaginatedLink(inputs: {
    baseLink: string;
    query: Record<string, string>;
    page: number;
}) {
    const finalLinkParts = [trailingSlashIt(inputs.baseLink)];

    if (inputs.query && (inputs.query.page || inputs.query.s)) {
        finalLinkParts.push(
            `?${new URLSearchParams(
                omitBy(
                    {
                        ...inputs.query,
                        // We don't need orderBy in links right now.
                        orderBy: undefined,
                        page: String(inputs.page),
                    },
                    isUndefined
                )
            ).toString()}`
        );
    } else {
        finalLinkParts.push(`page/${inputs.page + 1}/`);
    }

    return finalLinkParts.join('');
}

export function trailingSlashIt(url: string) {
    return url.endsWith('/') ? url : `${url}/`;
}
